import React from 'react';
import { Layout, Carousel, Row, Col } from 'antd';
import { Link } from 'react-router-dom';
import MadFactory from '../../resources/img/madfactory_thumb.png';
import ToU from '../../resources/img/tou_thumb.png';
import CubeFit from '../../resources/img/cubefit_thumb.png';
import Button from '../components/Button';
import Footer from '../components/Footer';
import SNSBox from '../components/SNSBox';

import Logo from '../../resources/img/logo_w.png';
import Left from '../../resources/img/left.png';
import Right from '../../resources/img/right.png';



const { Header, Content } = Layout;
const pages = [
    {
        title: 'MAD FACTORY',
        thumb: MadFactory,
        link: '/madFactory'
    },
    {
        title: 'Task of Universe',
        thumb: ToU,
        link: '/tou'
    },
    {
        title: 'Cube Fit',
        thumb: CubeFit,
        link: '/cubeFit'
    }
];



class Home extends React.Component {
    _carousel = React.createRef();

    constructor(props) {
        super(props);

        this.state = {
            index: 0
        }

        this._onChangeCarousel = this._onChangeCarousel.bind(this);
    }

    _onChangeCarousel(current) {
        this.setState({index: current});
    }

    render() {
        return (
            <Layout className={'fadeIn full-layout home'}>
                <Header className={'header home__header'}>
                    <div className={'home__logo'}>
                        <img className={'home__logo__img'} src={Logo} alt="logo"/>
                        <p className={'home__logo__text'}>GAME</p>
                    </div>
                </Header>
                <SNSBox/>
                <Content>
                    <Row justify={'center'} align={'middle'}>
                        <Col sm={4} xs={3}>
                            <div className={'home__buttons'}>
                                <Button icon={Left} disabled={pages.length < 2} onClick={() => this._carousel.current.prev()}/>
                            </div>
                        </Col>
                        <Col>
                            <div className={'home__carousel'}>
                                <Carousel ref={this._carousel} afterChange={this._onChangeCarousel}>
                                    {
                                        pages.map((page) => {
                                            return (
                                                <div key={page.title} className={'home__carousel__box'}>
                                                    <Link className={'home__carousel__link'} to={page.link}>
                                                        <img className={'home__carousel__img'} src={page.thumb} alt="img"/>
                                                        <div className={'home__carousel__link-box'}>
                                                            <p className={'home__carousel__title'}>{page.title}</p>
                                                        </div>
                                                    </Link>
                                                </div>
                                            );
                                        })
                                    }
                                </Carousel>
                            </div>
                        </Col>
                        <Col sm={4} xs={3}>
                            <div className={'home__buttons'}>
                                <Button icon={Right} disabled={pages.length < 2} onClick={() => this._carousel.current.next()}/>
                            </div>
                        </Col>
                    </Row>
                </Content>
                <Footer />
            </Layout>
        );
    }
}

export default Home;